import React from "react";
import "./tanakayu.scss";
import data from "../../data.json";
import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Heroimages from "../../../asset/hero/heroimages.js";
import Promoc from "../../../component/promo/promoc.jsx";
import hsimages from "../../../asset/hardsell/hsimages.js";
import prmo from "../../../component/promo/promocard.json";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import fastanakayu from "../../../asset/fascarousel/fas-tanakayu/fas-tanakayu.js";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import imgVasya from "../../../asset/imgrumah/img-tanakayu/img-vasya/img-vasya.js";
import imgChava from "../../../asset/imgrumah/img-tanakayu/img-chava/img-chava.js";
import imgJiva from "../../../asset/imgrumah/img-tanakayu/img-jiva/img-jiva.js";
import imgSvadhi from "../../../asset/imgrumah/img-tanakayu/img-svadhi/img-svadhi.js";
import Cardprodukdetail from "../../../component/cardprodukdetail/cardprodukdetail.jsx";
import Cardprodukdetail1 from "../../../component/cardprodukdetail/cardprodukdetail1.jsx";
const imgMap = {
  fastanakayu,
};
const imageMap = {
  imgVasya,
  imgChava,
  imgJiva,
  imgSvadhi,
};

const tanakayu = () => {
  return (
    <div className="tanakayu">
      <div className="hero">
        {data.tanakayuab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.tanakayuab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Tanakayu.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasTanakayu.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div className="produkcontainer">
        {dataproduk.Vasyap.map((card, index) => {
          return (
            <Cardprodukdetail1
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
      <div className="produkcontainer">
        {dataproduk.Tanakayup.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default tanakayu;
